
import { WorldCountry } from '../types';

export const philippinesExpanded4: WorldCountry = {
  name: 'Philippines',
  slug: 'philippines',
  code: 'PH',
  population: 109581078,
  topCities: [
    // Ciudades principales existentes
    { name: 'Quezon City', slug: 'quezon-city', population: 2936116 },
    { name: 'Manila', slug: 'manila', population: 1780148 },
    { name: 'Caloocan', slug: 'caloocan', population: 1583978 },
    { name: 'Davao City', slug: 'davao-city', population: 1776949 },
    { name: 'Cebu City', slug: 'cebu-city', population: 964169 },
    { name: 'Zamboanga City', slug: 'zamboanga-city', population: 977234 },
    { name: 'Antipolo', slug: 'antipolo', population: 887399 },
    { name: 'Pasig', slug: 'pasig', population: 803159 },
    { name: 'Taguig', slug: 'taguig', population: 886722 },
    { name: 'Valenzuela', slug: 'valenzuela', population: 714978 },
    
    // Ciudades adicionales para llegar a 100+
    { name: 'Iloilo City', slug: 'iloilo-city', population: 457626 },
    { name: 'Cagayan de Oro', slug: 'cagayan-de-oro', population: 675950 },
    { name: 'General Santos', slug: 'general-santos', population: 697315 },
    { name: 'Bacolod', slug: 'bacolod', population: 600783 },
    { name: 'Las Piñas', slug: 'las-pinas', population: 606293 },
    { name: 'Makati', slug: 'makati', population: 510383 },
    { name: 'Marikina', slug: 'marikina', population: 450741 },
    { name: 'Muntinlupa', slug: 'muntinlupa', population: 543445 },
    { name: 'Parañaque', slug: 'paranaque', population: 689992 },
    { name: 'Pasay', slug: 'pasay', population: 440656 },
    { name: 'Mandaluyong', slug: 'mandaluyong', population: 425758 },
    { name: 'San Juan', slug: 'san-juan', population: 126347 },
    { name: 'Malabon', slug: 'malabon', population: 380522 },
    { name: 'Navotas', slug: 'navotas', population: 249463 },
    { name: 'Pateros', slug: 'pateros', population: 65227 },
    { name: 'Lucena', slug: 'lucena', population: 278924 },
    { name: 'Baguio', slug: 'baguio', population: 366358 },
    { name: 'Dagupan', slug: 'dagupan', population: 171271 },
    { name: 'Laoag', slug: 'laoag', population: 111651 },
    { name: 'San Fernando La Union', slug: 'san-fernando-la-union', population: 125640 },
    { name: 'Tuguegarao', slug: 'tuguegarao', population: 166334 },
    { name: 'Cauayan', slug: 'cauayan', population: 143403 },
    { name: 'Ilagan', slug: 'ilagan', population: 145568 },
    { name: 'Santiago', slug: 'santiago', population: 134830 },
    { name: 'Tabuk', slug: 'tabuk', population: 121033 },
    { name: 'Bontoc', slug: 'bontoc', population: 8806 },
    { name: 'Lamitan', slug: 'lamitan', population: 103656 },
    { name: 'Balanga', slug: 'balanga', population: 104173 },
    { name: 'Malolos', slug: 'malolos', population: 261189 },
    { name: 'Meycauayan', slug: 'meycauayan', population: 225673 },
    { name: 'San Jose del Monte', slug: 'san-jose-del-monte', population: 651813 },
    { name: 'Marilao', slug: 'marilao', population: 254453 },
    { name: 'Santa Maria', slug: 'santa-maria-bulacan', population: 289820 },
    { name: 'Bocaue', slug: 'bocaue', population: 141412 },
    { name: 'Balagtas', slug: 'balagtas', population: 77018 },
    { name: 'Guiguinto', slug: 'guiguinto', population: 112981 },
    { name: 'Plaridel', slug: 'plaridel', population: 114432 },
    { name: 'Pulilan', slug: 'pulilan', population: 108836 },
    { name: 'Calumpit', slug: 'calumpit', population: 118471 },
    { name: 'Hagonoy', slug: 'hagonoy', population: 133448 },
    { name: 'Paombong', slug: 'paombong', population: 55696 },
    { name: 'Obando', slug: 'obando', population: 59978 },
    { name: 'Bulakan', slug: 'bulakan', population: 81232 },
    { name: 'San Ildefonso', slug: 'san-ildefonso', population: 118239 },
    { name: 'San Miguel', slug: 'san-miguel-bulacan', population: 180055 },
    { name: 'San Rafael', slug: 'san-rafael', population: 93768 },
    { name: 'Doña Remedios Trinidad', slug: 'dona-remedios-trinidad', population: 25841 },
    { name: 'Norzagaray', slug: 'norzagaray', population: 136064 },
    { name: 'Angat', slug: 'angat', population: 33073 },
    { name: 'Bustos', slug: 'bustos', population: 79388 },
    { name: 'Baliuag', slug: 'baliuag', population: 168470 },
    { name: 'Pandi', slug: 'pandi', population: 106808 },
    { name: 'Cabanatuan', slug: 'cabanatuan', population: 327325 },
    { name: 'Gapan', slug: 'gapan', population: 122968 },
    { name: 'San Jose', slug: 'san-jose-nueva-ecija', population: 150917 },
    { name: 'Muñoz', slug: 'munoz', population: 74903 },
    { name: 'Palayan', slug: 'palayan', population: 41041 },
    { name: 'Talavera', slug: 'talavera', population: 118373 },
    { name: 'Santo Domingo', slug: 'santo-domingo', population: 62234 },
    { name: 'Aliaga', slug: 'aliaga', population: 67992 },
    { name: 'Licab', slug: 'licab', population: 23161 },
    { name: 'Cabiao', slug: 'cabiao', population: 85862 },
    { name: 'San Leonardo', slug: 'san-leonardo', population: 66768 },
    { name: 'Jaen', slug: 'jaen', population: 79189 },
    { name: 'San Antonio', slug: 'san-antonio-nueva-ecija', population: 74900 },
    { name: 'Peñaranda', slug: 'penaranda', population: 33046 },
    { name: 'General Mamerto Natividad', slug: 'general-mamerto-natividad', population: 39594 },
    { name: 'Llanera', slug: 'llanera', population: 43177 },
    { name: 'Rizal', slug: 'rizal-nueva-ecija', population: 69422 },
    { name: 'Bongabon', slug: 'bongabon', population: 60446 },
    { name: 'Laur', slug: 'laur', population: 40132 },
    { name: 'Pantabangan', slug: 'pantabangan', population: 19532 },
    { name: 'Carranglan', slug: 'carranglan', population: 43744 },
    { name: 'Lupao', slug: 'lupao', population: 43156 },
    { name: 'General Tinio', slug: 'general-tinio', population: 46963 },
    { name: 'Quezon', slug: 'quezon-nueva-ecija', population: 29200 },
    { name: 'Guimba', slug: 'guimba', population: 129988 },
    { name: 'Cuyapo', slug: 'cuyapo', population: 79267 },
    { name: 'Nampicuan', slug: 'nampicuan', population: 13552 },
    { name: 'Zaragoza', slug: 'zaragoza', population: 50675 },
    { name: 'Olongapo', slug: 'olongapo', population: 260803 },
    { name: 'Angeles', slug: 'angeles', population: 462928 },
    { name: 'San Fernando Pampanga', slug: 'san-fernando-pampanga', population: 354666 },
    { name: 'Mabalacat', slug: 'mabalacat', population: 293244 },
    { name: 'Tarlac City', slug: 'tarlac-city', population: 385398 },
    { name: 'Urdaneta', slug: 'urdaneta', population: 144577 },
    { name: 'Alaminos', slug: 'alaminos', population: 99397 },
    { name: 'San Carlos', slug: 'san-carlos-pangasinan', population: 205424 },
    { name: 'Iba', slug: 'iba', population: 55581 },
    { name: 'Bolinao', slug: 'bolinao', population: 83979 },
    { name: 'Lingayen', slug: 'lingayen', population: 107728 },
    { name: 'Mangaldan', slug: 'mangaldan', population: 113185 },
    { name: 'Manaoag', slug: 'manaoag', population: 76045 },
    { name: 'Malasiqui', slug: 'malasiqui', population: 40018 },
    { name: 'Mapandan', slug: 'mapandan', population: 37018 },
    { name: 'Pozorrubio', slug: 'pozorrubio', population: 72797 },
    { name: 'Sison', slug: 'sison', population: 46473 },
    { name: 'Binalonan', slug: 'binalonan', population: 56382 },
    { name: 'Tayug', slug: 'tayug', population: 45241 },
    { name: 'Natividad', slug: 'natividad', population: 38542 },
    { name: 'San Quintin', slug: 'san-quintin', population: 35421 },
    { name: 'Umingan', slug: 'umingan', population: 78690 },
    { name: 'Balungao', slug: 'balungao', population: 31187 }
  ]
};
